const clipboardCopy = () => {
  const copyBtns = document.querySelectorAll('.js-copy-url')

  if (copyBtns) {
    Array.from(copyBtns).forEach((btn) => {
      btn.addEventListener('click', function () {
        const currentUrl = window.location.href
        const prevText = btn.innerHTML

        navigator.clipboard.writeText(currentUrl).then(function () {
          btn.innerHTML = 'Copied'
          btn.style.pointerEvents = 'none'

          setTimeout(() => {
            btn.style.pointerEvents = ''
            btn.innerHTML = prevText
          }, 3000)
        })
      })
    })
  }
}

export default clipboardCopy
